module.exports = __webpack_public_path__ + "img/Core-Culture-logo-new.4c0af0b3.svg";